// Publishing FunnelKeeper's tag into the live GTM container. Shared by the
// three places that offer it — the GTM connection card, Event tracking, and
// onboarding — so the confirm text and the read-only-grant recovery are the
// same wherever a human presses it.
import { api, ApiError } from "../api";

export const GTM_DEPLOY_CONFIRM =
  "This publishes a FunnelKeeper tag to the LIVE Google Tag Manager container. Continue?";

/** Deploy needs a write key to put in the tag. "Create a key first" is a step
 *  nobody guesses from a Deploy button, so mint one as part of the deploy —
 *  never when the product already has one, which would revoke it. */
export async function deployGtmTag(slug: string, hasKey?: boolean): Promise<string> {
  const known = hasKey ?? Boolean((await api.trackingKey(slug)).key);
  if (!known) await api.rotateTrackingKey(slug);
  try {
    const res = await api.deployTrackingGtm(slug);
    return `Published ${res.version_name} to the live container.`;
  } catch (e) {
    // Grants taken before the publish scopes were added can audit the
    // container but not write to it. Send the human back through consent.
    if (e instanceof ApiError && e.status === 403) {
      const start = await api.connect.start(slug, ["gtm"]);
      location.href = start.auth_url;
      return "That Google grant is read-only — reconnecting…";
    }
    throw e;
  }
}
